import ReturnToApp from './ReturnToApp';

export default ReturnToApp;
